<template>
  <div @click.prevent.stop="">
    <TransitionAccordion>
      <PopUpOverlay
        style="border: 1px solid var(--v-primary-base) !important"
        :width="`340px; max-width: ${max_width}px;`"
        :margin="8"
        :position_css="`position: fixed; top: 50vh; left: 50vw; transform: translate(-50%, -50%);`"
        @closeOverlay="$emit('closeOverlay')"
      >
        <!-- POP-UP DESCRIPTION -->
        <template #head>
          <div class="language-pop-up-horizontal">
            <TIcon name="speech-bubble" :color="color" small/>
            <h3 :style="`color: ${color}`">Languages</h3>
          </div>
        </template>

        <template #body>
          <div class="language-pop-up-vertical">
            <div v-for="country in getCountries" :key="`language-${country.language}-pop-up-input`">
              <!-- DESCRIPTION -->
              <div class="language-pop-up-horizontal">
                <CountryFlag :country="country.flag" size="small"/>
                <span :style="`color: ${color};`">{{ country.name }}</span>
              </div>
              <!-- INTERACTION -->
              <div class="language-pop-up-horizontal">
                <!-- INPUT FIELD -->
                <!-- <input
                  class="language-pop-up-input"
                  :style="`
                    border-color: ${color};
                    color: ${color};
                    ${country.language=='en' ? 'opacity: .67;' : ''}
                  `"
                  :value="getLan({value, language: country.language})"
                  :disabled="country.language=='en'"
                  @change="country.translation=$event"
                /> -->
                <DisableableInputField
                  :value="getLan({value, language: country.language})"
                  :width="'calc(100% - 88px)' /*NOTE: full width - button size (80px) - grid-gap (8px)*/"
                  align="left"
                  :is_disabled="country.language=='en'"
                  @change="country.translation=$event"
                />
                <!-- APPLY BUTTON -->
                <v-btn
                  v-if="country.language!='en'"
                  class="pop-up-overlay-component-v-btn"
                  @click="addTranslation({key: value, language: country.language, value: country.translation})"
                >
                  Apply
                </v-btn>
              </div>
            </div>
          </div>
        </template>

      </PopUpOverlay>
    </TransitionAccordion>

    <!-- <button @click="is_show_overlay=true, setShowLanguagePopUp(true)">
      <TIcon name="speech-bubble" size="16"/>
    </button> -->
  </div>
</template>

<script>
  import {mapGetters,mapActions} from 'vuex';
  import PopUpOverlay from '@/components/WorkPackageWIP/PopUpOverlay.component.vue';
  import TIcon from '@/components/Taktify/TIcon.component.vue';
  import DisableableInputField from '@/components/WorkPackageWIP/DisableableInputField.component.vue';
  import CountryFlag from 'vue-country-flag';
  import TransitionAccordion from '@/components/WorkPackageWIP/TransitionAccordion.component.vue';

  export default {
    props: ['value'],
    components: {
      PopUpOverlay,
      TIcon,
      CountryFlag,
      TransitionAccordion,
      DisableableInputField,
    },

    computed: {
      ...mapGetters('Language', [
        'getCountries',
        'getLan'
      ]),
      max_width() {
        return screen.width;
      },
      color() {
        if(this.$vuetify.theme.isDark)
          return '#FFF';
        return '#000';
      },
    },

    data: () => ({
      languages: [
        {lang:'English', short: 'us', value:'some unchangeable value',},
        {lang:'German', short:'de', value: 'ein unveränderbarer wert',},
        {lang:'Finnish', short:'fi', value: '',},
      ]
    }),

    methods: {
      ...mapActions('Language', [
        'addTranslation'
      ]),
      ...mapActions('View', [
        'setShowLanguagePopUp'
      ]),
      applyLanguage(language) {
        // console.log(language.changed_str);
        // TODO: actually apply changes
        if(language.changed_str || language.changed_str==='') {
          language.value = language.changed_str;
          language.changed_str = undefined; // remove temp attribute
        }
      }
    }
  }
</script>

<style>
.language-pop-up-horizontal {
  display: flex;
  grid-gap: 8px;
  align-items: center;
}
.language-pop-up-input {
  border: 1px solid;
  border-radius: 4px;
  width: calc(100% - 88px); /*NOTE: full width - button size (80px) - grid-gap (8px)*/
}
.language-pop-up-vertical {
  display: flex;
  flex-direction: column;
  grid-gap: 8px;
}
</style>
